export default __webpack_public_path__ + "static/media/banner.8c7b85a8.jpg";